import type { InventoryVehicle } from '@carvana/merch-contracts';
import { useEffectWithController } from '@carvana/merch-react-hooks';
import { useContext } from 'react';
import useGetClientId from '~/constants/srp/getClientId';
import { useUserId, useUserLocation } from '~/context/common/UserContext';
import InventoryContext from '~/context/srp/InventoryContext';
import { convertAvailabilityVehiclesToMap } from '~/hooks/srp/services/useGetAvailability/helpers';
import fetchVehiclesDeliveryPickup, {
  formatVehicleForRequest
} from '~/services/common/fetchVehiclesDeliveryPickup';
import { generateErrorLogger } from '~/utilities/loggers';

export default function useGetSrpVehicleAvailability(
  vehicles: Array<InventoryVehicle>
): void {
  const {
    inventoryBulkData: { setData }
  } = useContext(InventoryContext);
  const { zip } = useUserLocation();
  const clientId = useGetClientId();
  const userId = useUserId();

  useEffectWithController(
    controller => {
      if (vehicles.length === 0) return;

      fetchVehiclesDeliveryPickup(
        {
          clientId,
          correlationId: '',
          userId,
          vehicles: vehicles.map(formatVehicleForRequest),
          zip
        },
        controller
      )
        .then(res => {
          if (res.data.status !== 'Succeeded') return;

          const vehicleAvailabilities = convertAvailabilityVehiclesToMap(
            res.data.content ?? []
          );

          setData(prevData => ({ ...prevData, ...vehicleAvailabilities }));
        })
        .catch(
          generateErrorLogger(
            'Availability (SRP free-text no-results)',
            {},
            { controller }
          )
        );
    },
    [clientId, setData, userId, vehicles, zip]
  );
}
